import api from './api';

export interface GenerateSupportTokenResponse {
  success: boolean;
  message: string;
  token: string;
}

export const supportTokenService = {
  /**
   * Gera um novo token de suporte
   * @param userId - ID do usuário
   * @returns Token de suporte gerado
   */
  generateToken: async (userId: string): Promise<GenerateSupportTokenResponse> => {
    const response = await api.post('/support-request', { userId });
    return response;
  },
};
